import { render, staticRenderFns } from "./SelectedPrivilegeDetail.vue?vue&type=template&id=6d6e1f58&scoped=true&"
import script from "./SelectedPrivilegeDetail.vue?vue&type=script&lang=js&"
export * from "./SelectedPrivilegeDetail.vue?vue&type=script&lang=js&"
import style0 from "./SelectedPrivilegeDetail.vue?vue&type=style&index=0&id=6d6e1f58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e1f58",
  null
  
)

export default component.exports